import { getAnalytics, isSupported } from 'firebase/analytics'
import { getApp, getApps, initializeApp } from 'firebase/app'
import { getAuth, getIdToken, signInAnonymously } from 'firebase/auth'

export function setupFirebase() {
  const config = {
    apiKey: 'AIzaSyCCQrOdS9Yg2JdypZGxm6QH7Odt9X_wJ0s',
    authDomain: 'kids-art-book.firebaseapp.com',
    projectId: 'kids-art-book',
    storageBucket: 'kids-art-book.appspot.com',
    messagingSenderId: '325646427588',
    appId: '1:325646427588:web:3279091b5ba034edc83091',
    measurementId: 'G-BWZ056MZ6V',
  }
  const app = getApps().length ? getApp() : initializeApp(config)
  isSupported().then(supported => supported && getAnalytics(app)).catch(console.error)
}

export function signInFirebaseAnonymously() {
  return signInAnonymously(getAuth())
}

export async function getFirebaseToken() {
  const user = getAuth().currentUser
  if (!user) throw new Error('No Firebase user')
  return getIdToken(user)
}
